import React from 'react'
import PropTypes from 'prop-types'
import { withHandlers, compose } from 'recompose'

const enhance = compose(
  withHandlers({
    onRadioButtonChange: ({ onChange }) => e => {
      onChange(e.target.value)
    },
    isChecked: ({ value }) => option => {
      return value === option.value || (!value && !option.value)
    }
  })
)

const BedroomsBaths = ({ options, onRadioButtonChange, name, legend, isChecked }) => (
  <fieldset className='BedroomsBaths'>
    <legend className='BedroomsBaths-legend'>{legend}</legend>
    <div className='BedroomsBaths-options'>
      {options.map(option => (
        <div key={option.label} className='BedroomsBaths-option'>
          <label className='BedroomsBaths-label' htmlFor={`${name}-${option.value}`}>
            <input
              id={`${name}-${option.value}`}
              name={name}
              className='BedroomsBaths-input'
              type='radio'
              checked={isChecked(option)}
              value={option.value}
              onChange={onRadioButtonChange}
              aria-checked={isChecked(option)}
            />
            <span className='BedroomsBaths-content'>
              {option.label}
            </span>
          </label>
        </div>
      ))}
    </div>
  </fieldset>
)

BedroomsBaths.propTypes = {
  isChecked: PropTypes.func,
  legend: PropTypes.string.isRequired,
  name: PropTypes.string,
  onRadioButtonChange: PropTypes.func.isRequired,
  options: PropTypes.array
}

export default enhance(BedroomsBaths)